import { CSSProperties, MutableRefObject } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from "@dnd-kit/utilities"

/**
 * Provide parameters to direct child html elements in Sortable components
 */
export const useSortableItem = (id: number, disabled: boolean = false) => {
  const {attributes, listeners, setNodeRef, transform, transition} = useSortable({id})
  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'pointer',
  }
  return disabled ?
    {} :
      {ref: setNodeRef, style, ...attributes, ...listeners}
}

export const useSortableItemWithActivator = (id: number) => {
  const {attributes, listeners, setNodeRef, transform, transition, setActivatorNodeRef} = useSortable({id})
  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'pointer',
  }
  return {ref: setNodeRef, style, ...attributes, listeners, setActivatorNodeRef}
}